import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { LgvModel } from '../../data-models/longevity.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LgvEmailModel } from '../../data-models/lgv-email-model';

@Component({
    selector: 'lgv-link-email-to-client-modal',
    templateUrl: './link-email-to-client-modal.component.html',
    styleUrls: ['./link-email-to-client-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LinkEmailToClientModalComponent implements OnInit, OnDestroy {

    @Output() clientDTOSelected = new EventEmitter<any>();

    onDestroy$ = new Subject();

    selectedAgentId:string;
    selectedAgentOrganizationId: string;
    selectedAgentCompanyId: string;
    selectedClient: LgvModel.ClientDTO;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<LinkEmailToClientModalComponent>) {
        this.selectedAgentId = data.selectedAgentId;
        this.selectedAgentOrganizationId = data.selectedAgentOrganizationId;
        this.selectedAgentCompanyId = data.selectedAgentCompanyId;
     }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    selectClient(clientInfo: LgvModel.ClientDTO){
        this.selectedClient = clientInfo;
    }

    onSubmit(){
        this.clientDTOSelected.emit(this.selectClient);
        this.dialogRef.close({ action: true, selectedClient: this.selectedClient });
    }

    onCancel() {
        this.dialogRef.close({ action: false });
    }

}
